'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.terms',
dependencies:['ui.router'],
configs:[
require('./termsConfig')],

components:[
require('./termsController')]});
//# sourceMappingURL=index.js.map
